import ApiService from './ApiService';

export default class ReviewApi extends ApiService {
    constructor() {
        super('reviews');
    }

    getAllReviews(payload) {
        return this.get('', payload);
    }

    getReviewDetail(id) {
        return this.get(id);
    }

    publishReview(id) {
        return this.put(`publish/${id}`);
    }

    deleteReview(id) {
        return this.delete(`${id}`);
    }

    postSeedingComments(data) {
        return this.post('shops-search-seeding-comments', data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    }

    editSeedingComments(payload) {
        const { id, ...data } = payload;
        return this.put(`shops-search-seeding-comments/${id}`, data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    }
}
